import { OAuthRedirect } from './OAuthRedirect';

export const BlackboardOAuthRedirect = () => {
  return (
    <OAuthRedirect provider="Blackboard" apiEndpoint="transformer" authCodePath="bsAuthCode" />
  );
};
